import React from 'react';
import { toDay } from '../../utils/dateTypes';
import { hasEvent, isWeekBoundary, getBorderRadius } from './utils';
import { Container, Wrapper, Timeline, TickContainer, Tick, Dot } from './styles';

export interface DaySequenceBinaryRendererProps {
  allDates: Date[];
  eventSet: Set<string>;
  totalDays: number;
  dotWidth: number;
  dotHeight: number;
  borderRadius: number;
  showWeekTicks: boolean;
  color: string;
}

export const DaySequenceBinaryRenderer: React.FC<DaySequenceBinaryRendererProps> = ({
  allDates,
  eventSet,
  dotWidth,
  dotHeight,
  borderRadius,
  showWeekTicks,
  color
}) => {
  return (
    <Container>
      <Wrapper>
        <Timeline height={dotHeight}>
          {allDates.map((date, index) => {
            const isWeekBorder = isWeekBoundary(index, showWeekTicks);
            const hasDayEvent = hasEvent(date, eventSet);
            const backgroundColor = hasDayEvent ? color : (isWeekBorder ? '#e5e7eb' : 'transparent');
            const computedBorderRadius = getBorderRadius(index, allDates, eventSet, borderRadius);

            return (
              <Dot
                key={date.toISOString()}
                leftPosition={(index / allDates.length) * 100}
                width={dotWidth}
                height={dotHeight}
                backgroundColor={backgroundColor}
                borderRadius={computedBorderRadius}
                title={toDay(date)}
              />
            );
          })}
        </Timeline>

        {showWeekTicks && (
          <TickContainer>
            {allDates.map((_, index) => {
              if (!isWeekBoundary(index, showWeekTicks)) return null;

              return (
                <Tick key={`tick-${index}`} leftPosition={(index / allDates.length) * 100} />
              );
            })}
          </TickContainer>
        )}
      </Wrapper>
    </Container>
  );
};